import { IDSource } from "fieldpro-tools";
import _ from "lodash";

import { insertNewItemToArr } from "utils/reducerUtils";

import {
  INotification,
  INotificationState,
  INotificationWithTimestamp,
} from "./sliceTypes";

const NOTIFICATION_DUPLICATE_TIMEOUT = 10000;

export const formatNotification = (
  notification: INotification,
): INotificationWithTimestamp => ({
  ...notification,
  timestamp: Date.now(),
  id: IDSource(),
});

export const getExistingNotification = (
  notifications: INotificationState["allNotifications"],
  notification: INotificationWithTimestamp,
) => {
  return _.find(notifications, {
    message: notification.message,
    level: notification.level,
  });
};

export const isRecentDuplicate = (
  notification: INotificationWithTimestamp,
  existingNotification?: INotificationWithTimestamp,
): boolean => {
  if (!existingNotification) {
    return false;
  }

  const timeDifference =
    notification.timestamp - (existingNotification.timestamp ?? 0);
  return timeDifference < NOTIFICATION_DUPLICATE_TIMEOUT;
};

export const getUpdatedNotifications = (
  notifications: INotificationState["allNotifications"],
  notification: INotificationWithTimestamp,
  existingNotification?: INotificationWithTimestamp,
) => {
  if (!existingNotification) {
    return insertNewItemToArr(notifications, notification);
  }

  const filteredNotifications = _.reject(
    notifications,
    _.pick(notification, "level", "message"),
  );
  return insertNewItemToArr(filteredNotifications, notification);
};

export const updateNotificationsByLevel = (
  byLevel: Record<string, INotificationWithTimestamp[]>,
  notification: INotificationWithTimestamp,
) => {
  const levelToUpdate = byLevel[notification.level] || [];
  const notificationLevelUpdate = insertNewItemToArr(
    levelToUpdate,
    notification,
  );

  return {
    ...byLevel,
    [notification.level]: notificationLevelUpdate,
  };
};
